import { FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import React from "react";
import { Spinner } from "./Spinner";
import styled from "@emotion/styled";

interface Props {
  loading: boolean;
  text?: React.ReactNode;
  size?: FontAwesomeIconProps["size"];
  className?: string;
}

export const LoadingSpinner: React.FC<Props> = ({
  className,
  loading,
  size,
  text,
  children,
}) => {
  return loading ? (
    <div
      className={cn(
        "flex justify-center",
        { "flex-col items-center": text },
        className
      )}
    >
      {text && <div className="mb-3">{text}</div>}
      <Spinner size={size} />
    </div>
  ) : (
    <>{children}</>
  );
};

export const CenterSpinner = styled(LoadingSpinner)`
  align-items: center;
  height: 100vh;
`;
